import { Card, Col, Collapse, Divider, Form, Row, message, Result, Descriptions, Alert, Skeleton, Button } from "antd";
import React, { useEffect, useState } from "react";
import AutoCollectAPI from "../../services/api/autoCollect";
import SmartPayError from "../error";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { ClockCircleOutlined, CloudDownloadOutlined } from "@ant-design/icons";
import "./index.css"
import { base64ToPDF } from "../../utility";
import { HeaderComponent } from "../../shared_components";
import UploadSignedMandate from "./upload_signed_mandate";

const AUTO_DEBIT_FIELDS = {
    "mode": { label: "Payment Mode", formatter: (v) => v },
    "max_debit_amount": { label: "Mandate Amount", formatter: (v) => `Rs ${v} only` },
    "final_collection_date": { label: "Final collection Date", formatter: (v) => v }
}

const PaymentInfoFields = {
    "firstname": { label: "First Name", key: '' },
    "email": { label: "Email", key: '' },
    "phone": { label: "Phone", key: '' },
    "status": {
        'label': "Payment Status",
        'key': '',
        'valuemapper': {
            "success": "Success",
            'user_cancelled': "Cancelled by user",
            'failed': 'Failure',
            'initiated': 'Notification Request Sent',
            'pending': 'Pending',
            'processing': 'Processing',
            'expired': 'Expired',
            'dropped': 'Dropped',
            'bounced': 'Bounced',
            'authorized': "Authorized",
            "requested": 'Requested',
            'revoked': 'Revoked',
            'paused': 'Paused',
            'cancelled': 'Cancelled',
            'rejected': 'Rejected',
            'cancelling': 'Cancelling',
        }
    },
    "amount": { label: "Amount", key: '' },
    "reference_id": { label: "Transaction ID", key: '' },
    "transaction_id": { label: 'Reference ID', key: ''}, //This is reference ID for the merchant for auth link
    'description': { label: 'Remarks', key: '' },
    // "mode": { label: "Mandate Mode", key: 'debit_details' },
    // "final_collection_date": { label: "Final Collection Date", key: 'debit_details' },
}

const AutoCollect = (props) => {
    const { propsLinkData } = props
    const [linkData, setlinkData] = useState({})
    const [validatedAmount, setValidatedAmount] = useState(0)
    const [isPaymentRequestInitiated, setPaymentRequest] = useState(false)
    const [valid_transaction, setValidTransaction] = useState(true)
    const [error, setError] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [errorDetails, setErrorDetails] = useState({})
    const [form] = Form.useForm()
    const { url } = useParams();
    const { Panel } = Collapse;
    const isMobile = window.innerWidth <= 810

    useEffect(() => getLinkDetails(propsLinkData?.valid ? propsLinkData : {}), [])

    const createSeamlessForm = (data, url) => {
        var seamless_form = document.createElement("form");
        seamless_form.method = "POST";
        seamless_form.action = url
        Object.entries(data).forEach(([key, val]) => {
            var element = document.createElement("input");
            element.type = "hidden";
            element.name = key
            element.value = val;
            seamless_form.appendChild(element);
        });
        document.body.appendChild(seamless_form);
        seamless_form.submit();
    }

    const getLinkDetails = async (propsLinkData) => {
        if (propsLinkData?.valid) {
            setlinkData(propsLinkData)
            setValidatedAmount(propsLinkData.amount)
            setValidTransaction(true)
            setIsLoading(false);
        } else {
            setIsLoading(true);
            await AutoCollectAPI.get_mandate(url).then((response) => {
            if (response.status && response.data.valid) {
                let data = response.data;
                if (data?.redirect_transaction) {
                  window.location.href = `/auto-collect/${url}/response/${data.redirect_transaction}`
                } else {
                  setlinkData(data)
                  setValidatedAmount(data.amount)
                  setValidTransaction(true)
                }
            }
            else {
                setlinkData({})
                setValidTransaction(false)
                setError(true)
            }
        }).catch((error) => {
            setlinkData({})
            setValidTransaction(false)
            setError(true)
        }).finally(() => {
            setIsLoading(false);
        })
    }
    }


    const handlePaymentCall = async () => {
        const autoSubmitForm = (response, apiResponse) => {
            if(!response.transaction_id){
                response = {
                    ...response,
                    ...{'transaction_id': apiResponse.ref_id, 'id': null }
                }
            }
            var form = document.createElement("form");
            form.method = "POST";
            form.action = process.env.REACT_APP_PARTIAL_PAYMENT_URL + "auto-collect/response/" + url + "/";
            let addInputs = (response, parentKey = "") => {
                for (let key in response) {
                    if (response.hasOwnProperty(key)) {
                        let fullKey = parentKey ? `${parentKey}.${key}` : key;
                        if (typeof response[key] === "object" && response[key] !== null) addInputs(response[key], fullKey);
                        else {
                            const input = document.createElement("input");
                            input.type = "hidden";
                            input.name = fullKey;
                            input.value = response[key];
                            form.appendChild(input);
                        }
                    }
                }
            }
            addInputs(response)
            document.body.appendChild(form);
            form.submit();
        }
        setPaymentRequest(true);
        const response = await AutoCollectAPI.register_mandate(url);
        if (response.status) {

            if (response.is_seamless_request && response.seamless)
                createSeamlessForm(response.seamless.payload, response.seamless.url);
            else {
                if (response.is_hosted) {
                    window.open(response.url + response.access_key, "_self")
                }
                else {
                    const easebuzzCheckoutClass = window.EasebuzzCheckout;
                    var easebuzzCheckout = new easebuzzCheckoutClass(response.access_key, process.env.REACT_APP_ENV)
                    var options = {
                        access_key: response?.access_key, // access key received via Initiate Payment
                        theme: "#123456", // color hex
                        onResponse: (checkoutResponse) => autoSubmitForm(checkoutResponse, response)
                    }
                    easebuzzCheckout.initiatePayment(options);
                }
            }
            setPaymentRequest(false);
        }
        else {
            if (response.mandate_transaction_id) {
                setErrorDetails(response)
            }
            setPaymentRequest(false);
            message.error(response.error);
        }
    }

    const getFirstNameInfo = () => {
        return (
            <div className="gap-1" style={isMobile ? { marginLeft: 10 } : null}>
                <p className="batch">  Hi {linkData?.firstname} ,</p>
                <p>Please confirm your personal information</p>
            </div>
        )
    }

    const getEmailInfo = () => {
        if (linkData?.email) {
            return (
                <div className="gap">
                    <p className="batch" style={{ color: "#7A8699", fontSize: "14px" }}> Email ID</p>
                    <p className="batch text">{linkData?.email}</p>
                </div>
            )
        }
    }

    const getPhoneInfo = () => {
        if (linkData?.phone) {
            return (
                <div className="gap">
                    <p className="batch" style={{ color: "#7A8699", fontSize: "14px" }}> Phone</p>
                    <p className="batch text">
                        {linkData?.phone}
                    </p>
                </div>
            )
        }
    }

    const getAdditionalInfo = () => {
        return (
            ["udf1", "udf2", "udf3", "udf4", "udf5", "message"].map((key) => {
                return <>
                    {
                        linkData[key] &&
                        <div className="" style={{ marginBottom: "7px" }}>
                            <p className="batch" style={{ color: "#7A8699", fontSize: "14px" }}>{linkData.easycollect_fields[key]}</p>
                            <p className="batch text">
                                {linkData[key]}
                            </p>
                        </div>
                    }
                </>
            })
        )
    }

    const AutoDebitDetails = () => {
        if (linkData.is_auto_debit_link && linkData.debit_details) {
            const autoDebitFields = Object.entries(AUTO_DEBIT_FIELDS).map(([key, value]) => (
                <div key={key} style={{ marginBottom: "7px" }}>
                    <p className="batch" style={{ color: "#7A8699", fontSize: "14px" }}>{value.label}</p>
                    <p className="batch text">
                        {value.formatter(linkData.debit_details[key])}
                    </p>
                </div>
            ))
            const AutoDebitNote = () => (linkData.debit_details.mode !== "SI" && (<p>*Note - No money will be deducted on authorization</p>)) || null
            return (
                <>
                    <div className="gap-1">
                        <p className="batch">Payment Details</p>
                        <p className="batch-2">Please confirm your payment details</p>
                        {autoDebitFields}
                        <p>Please authorize mandate for a deduction amount of Rs {validatedAmount} only</p>
                        <AutoDebitNote />
                    </div>
                </>
            )
        }
        return null
    }

    const FormDetails = () => {
        if (linkData.payment_made) {
            return (
                <div>
                    <div style={{ margin: "0px auto", width: "100px", textAlign: "center", paddingTop: "82px" }}>
                        <lottie-player
                            src="https://ebz-static.s3.ap-south-1.amazonaws.com/partial_payment/Success.json"
                            background="transparent" speed="1" loop={false} autoplay></lottie-player>
                    </div>
                    <h3 style={{ textAlign: "center" }}>Payment on this link has been done</h3>
                </div>
            )
        }
        else {
            return (
                <>
                    <Form
                        // style={{ marginTop: 10 }}
                        form={form}
                        onFinish={handlePaymentCall}
                    >
                        <Form.Item>
                            <span className="auto_collect_footer_section">
                                <button
                                    loading={isPaymentRequestInitiated}
                                    block
                                    className={isMobile ? "pay-button" : "pay"}
                                    style={{ background: "#4E5FF9", color: "#ffff", marginTop: "5px" }}
                                    htmlType="submit"
                                >
                                    <b>
                                        <img
                                            style={{ marginRight: "5px" }} alt=""
                                            src="https://ebz-static.s3.ap-south-1.amazonaws.com/partial_payment/download.png"
                                        />
                                        Register Now
                                    </b>
                                </button>
                            </span>
                        </Form.Item>
                    </Form>
                </>

            )
        }

    }

    const PaymentPage = () => {
        const DisplayErrorDetails = () => {
            if (Object.keys(errorDetails).length !== 0) {
                return (
                    <Col span={24} style={{ margin: "0px", padding: "0px" }}>
                        <Alert style={{ padding: "5px", margin: "0px" }} message={
                            <Collapse defaultActiveKey={["1"]} expandIconPosition="right" accordion ghost >
                                <Panel className="error_panel_class" style={{ margin: "0px", padding: "0px" }}
                                    header={errorDetails.error} key="1">
                                    <div>
                                        <span><b>Transaction ID :</b> {errorDetails.mandate_transaction_id}</span><br />
                                        <span><b>Mandate status :</b> {errorDetails.mandate_status}</span>
                                    </div>
                                </Panel>
                            </Collapse>
                        } />
                    </Col>
                )
            }
            return null
        }

        if (Object.keys(linkData).length !== 0 && valid_transaction) {
            return (
                <>
                    <div className={isMobile ? "mobile-main-section" : "main-section"}>
                        <Card variant="borderless" cover={<HeaderComponent logo={linkData.m_logo} name={linkData.m_name} />} className={isMobile ? "mobile-wrapper" : "easycollect-card"}>
                            <Skeleton loading={isLoading} paragraph={{ rows: 20 }}>
                                <Row>
                                    <DisplayErrorDetails />
                                    <Col span={24}>
                                        <p style={{ fontSize: "20px", marginTop: '10px' }}>{linkData.is_auto_debit_link ? 'Mandate authorization Request' : null}</p>
                                        {/* <Divider hidden={isMobile ? true : false}  /> */}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={11} lg={11} xs={24}>
                                        {
                                            isMobile ?
                                                <Collapse ghost className="collapse-mobile" defaultActiveKey={["1"]} expandIconPosition="right" accordion >
                                                    <Panel className="easycollect-mobile-panel" header={getFirstNameInfo()} key="1">
                                                        {getEmailInfo()}
                                                        {getPhoneInfo()}
                                                        {getAdditionalInfo()}
                                                    </Panel>
                                                </Collapse>
                                                :
                                                <>
                                                    {getFirstNameInfo()}
                                                    {getEmailInfo()}
                                                    {getPhoneInfo()}
                                                    {getAdditionalInfo()}
                                                </>
                                        }
                                    </Col>
                                    <Divider type="vertical" className="divider-line" style={{ height: "42vh" }} hidden={isMobile ? true : false} />
                                    <Col span={11} lg={11} xs={24}>
                                        {AutoDebitDetails()}
                                        {FormDetails()}
                                    </Col>
                                </Row>
                                <Row >
                                    <Col xl={{ span: 16 }} lg={{ span: 16 }} xs={{ span: 24 }} className={isMobile ? "support-mobile" : "support-desktop"}>
                                        <p style={{ color: "#7A8699" }}> For any queries, please contact us at <a href="mailto:support@easebuzz.in">support@easebuzz.in</a></p>
                                    </Col>
                                    <Col xl={{ span: 8 }} lg={{ span: 8 }} xs={{ span: 24 }} className={isMobile ? "centered-logo" : "powered-by-easebuzz"}>
                                        <img alt="" src="https://ebz-static.s3.ap-south-1.amazonaws.com/logo/Group+3097poweredbyeasebuzz.svg" />
                                    </Col>
                                </Row>
                            </Skeleton>
                        </Card>
                    </div>
                </>
            )
        }
        else if (error) {
            return (<SmartPayError status={400} title={error} />)
        }
    }

    return (
        <>
            {PaymentPage()}
        </>
    )
}

const AutoCollectResponse = () => {

    const [data, setData] = useState({})
    const [error, setError] = useState(null)
    const { url, reference_id } = useParams();
    const [isLoading, setIsLoading] = useState(true)
    const isMobile = window.innerWidth <= 810

    useEffect(() => {
        getLinkResponse();
        // document.body.style.backgroundImage = "url('../../assets/images/easycollect.png')";
        // console.log(document.body.style.backgroundImage)
    }, [])

    const getLinkResponse = async () => {
        setIsLoading(true);
        if(!reference_id || reference_id === "failure"){
            setIsLoading(false);
            setError("Unable to retrieve response")
        }
        else{
            await AutoCollectAPI.get_response(url, reference_id).then((response) => {
                if (response.status) {
                    setData(response.data);
                }
                else {
                    setError(response?.error)
                }
            }).catch((error) => {
                setError("Link not found")
            }).finally(() => {
                setIsLoading(false);
            })
        }
    }

    const PaymentInfo = () => {
        const mandate_mapping = {
                true: {
                    "ENACH": {
                        "Physical": {
                            title: "Physical Nach generated successfully!",
                            subTitle: "Kindly download the file by clicking the Download button below",
                            status: "success",
                            extra:
                                (data?.status === "initiated") && (
                                    <div className="enach_physical_button_container">
                                        <Button onClick={DownloadPaperNach} type="primary">
                                            <CloudDownloadOutlined /> Download PaperNach
                                        </Button>
                                        {data?.allow_mandate_upload && (
                                            <UploadSignedMandate
                                                key="upload-signed-mandate"
                                                url={url}
                                                transactionId={data?.transaction_id}
                                                phone={data?.phone}
                                            />
                                        )}
                                    </div>
                                )

                        },
                        title: "e-NACH Mandate Registration Successful",
                        status: "success"
                    },
                    "UPI": {
                        title: "UPI Mandate Initiated Successfully",
                        status: "success",
                        icon: <ClockCircleOutlined />
                    },
                "UPI-SBMD": {
                    title: "UPI Mandate Initiated Successfully",
                    status: "success",
                    icon: <ClockCircleOutlined />
                },
                    "SI": {
                        title: "SI Mandate Initiated Successfully",
                        status: "success",
                    }
                },
                false: {
                    "ENACH": {
                        title: "e-NACH Mandate Registration Failed",
                        status: "error"
                    },
                    "UPI": {
                        title: "Failed to Initiate UPI Mandate",
                        status: "error",
                    },
                    "UPI-SBMD": {
                        title: "Failed to Initiate UPI Mandate",
                        status: "error",
                    },
                    "SI": {
                        title: "Failed to Initiate SI Mandate",
                        status: "error",
                    }
                }
            }
        const normal_mapping = {
            true: {
                title: "Payment Successful",
                status: "success"
            },
            false: {
                title: "Payment Failed",
                status: "error"
            }
        }
        let fields = {}
        let resultProps = {}
        if(data && !error){
            let is_mandate = data?.debit_details?.mode || null;
            resultProps = normal_mapping[data?.payment_made];
            if (is_mandate) {
                resultProps = mandate_mapping[data?.payment_made][data?.debit_details?.mode];
                if (data?.is_paper_nach)
                    resultProps = mandate_mapping[data?.payment_made][data?.debit_details?.mode]["Physical"];
            }
            fields = Object.entries(PaymentInfoFields).map(([key, value]) => {
                const valuemapper = value?.valuemapper || {};
                let value_ = !value.key ? data[key] : data?.debit_details ? data[value.key][key] : ''
                value_ = valuemapper[value_] ? valuemapper[value_] : value_;
                return (
                    <Descriptions.Item key={key} style={{ marginBottom: "7px" }} label={value.label} span='filled'>
                        {value_}
                    </Descriptions.Item>
                )
            })
        }
        else{
            resultProps = normal_mapping[false];
            resultProps.title = "Unable to verify the payment status for the link"
            fields = (
                <>
                    <Descriptions.Item key="message" style={{ marginBottom: "7px" }} label="Error" span='filled'>
                        No response recieved from the intermdediate system.
                        <br/>
                        The potential causes can be
                        <ol type="1">
                            <li>Invalid response from the intermdediate system</li>
                            <li>Delay in response from the bank's end</li>
                            <li>Issue with the current flow with the intermdediate system</li>
                            <li>Incorrect/Malformed reference ID provided in the response</li>
                        </ol>
                    </Descriptions.Item>
                    <Descriptions.Item key="retry" style={{ marginBottom: "7px" }} label="Retry" span="filled">
                        Click <a href={process.env.REACT_APP_AUTOCOLLECT_URL + url }>here</a> to retry
                    </Descriptions.Item>
                </>
            )

        }
        return (
            <div className="payment-info">
                <Result style={{ textAlign: "center" }} {...resultProps} />
                <Descriptions bordered>
                    {fields}
                </Descriptions>
            </div>
        )
    }

    const DownloadPaperNach = () => {
        let queryData = {
            url: url,
            transaction_id: data?.transaction_id
        }
        message.loading("Downloading Paper-NACH Mandate", 0.8).then(
            AutoCollectAPI.get_mandate_details(queryData).then((response) => {
                if (response.status) {
                    base64ToPDF(response.data.data.paper_enach_document, `Autocollect_Papernach_${reference_id}_${new Date().toISOString().slice(0, 10)}.pdf`)
                    message.success("PaperNach Mandate Downloaded Successfully!")
                }
                else setError(response?.error)
            }).catch((error) => {
                setError("Could not download the PaperNach Mandate")
            })
        )
    }

    const PaymentResponse = () => {
        if (data) {
            return (
                <div className={isMobile ? "mobile-main-section" : "main-section"}>
                    <Card variant="borderless" cover={<HeaderComponent logo={data.m_logo} name={data.m_name} />} className={isMobile ? "mobile-wrapper" : "easycollect-response-card"}>
                        <Skeleton loading={isLoading} paragraph={{ rows: 20 }}>
                            <Row className="easycollect-response-card-col-1">
                                <Col span={24}>
                                    <PaymentInfo />
                                </Col>
                            </Row>
                            <Row className="easycollect-response-card-col-2">
                                <Col xl={{ span: 16 }} lg={{ span: 16 }} xs={{ span: 24 }} className={isMobile ? "support-mobile" : "support-desktop"}>
                                    <p style={{ color: "#7A8699" }}> For any queries, please contact us at <a href="mailto:support@easebuzz.in">support@easebuzz.in</a></p>
                                </Col>
                                <Col xl={{ span: 8 }} lg={{ span: 8 }} xs={{ span: 24 }} className={isMobile ? "centered-logo" : "powered-by-easebuzz"}>
                                    <img alt="" src="https://ebz-static.s3.ap-south-1.amazonaws.com/logo/Group+3097poweredbyeasebuzz.svg" />
                                </Col>
                            </Row>
                        </Skeleton>
                    </Card>
                </div>
            )
        }
        if (error) {
            return (<SmartPayError status={400} title={'Not Found'} />)
        }
    }

    return <PaymentResponse />

}
export { AutoCollect, AutoCollectResponse };
